<bp-hl-area-container name="Naturraum">
	<div class="touch-form">
		<div class="form-section-header">Geologie/Morphologie/Wuchsgebiet</div>

		<!-- Geologie / Klimastufe -->
		<div class="form-row">
			<div class="form-label-cell">Geologie</div>
			<div class="form-input-cell multi">
				<wd-typeahead name="GeologieOben" label="oben" [(model)]="data.extendedHeader.geologie.oben"></wd-typeahead>
				<wd-list-input name="GeologieTrenner" options="|/|//" [(model)]="data.extendedHeader.geologie.trenner"></wd-list-input>
				<wd-typeahead *ngIf="data.extendedHeader.geologie.trenner" name="GeologieUnten" label="unten" [(model)]="data.extendedHeader.geologie.unten"></wd-typeahead>
			</div>
			<div class="form-label-cell">Klimastufe</div>
			<div class="form-input-cell">
				<wd-an-typeahead name="Klimastufe" [(model)]="data.extendedHeader.klimaStufe" [acceptOtherValues]="true"></wd-an-typeahead>
			</div>
		</div>

		<!-- Wuchsgebiet -->
		<div class="form-row">
			<div class="form-label-cell">Wuchsgebiet</div>
			<div class="form-input-cell">
				<wd-typeahead name="Wuchsgebiet" [(model)]="data.extendedHeader.wuchsgebiet"></wd-typeahead>
			</div>
			<div class="form-label-cell">Wuchsbezirk</div>
			<div class="form-input-cell">
				<wd-typeahead name="Wuchsbezirk" [(model)]="data.extendedHeader.wuchsbezirk" [filter]="wuchsbezirkFilter(data.extendedHeader.wuchsgebiet)"></wd-typeahead>
			</div>
		</div>

		<!-- Morphologie und KMgCaP-Serie stehen bei den uebrigen Kopfangaben
		     (Geologie, Klimastufe, Wuchsgebiet, Wuchsbezirk) - so wie in der
		     Uebersicht. Sie gehoeren zum Abschnitt oben, einen eigenen
		     Balken bekommen sie nicht. -->
		@if (!isM()) {
			<div class="form-row">
				<div class="form-label-cell">Morphologie 1</div>
				<div class="form-input-cell">
					<wd-typeahead name="Morphologie0" [(model)]="data.extendedHeader.morphologie[0]"></wd-typeahead>
				</div>
				<div class="form-label-cell">Morphologie 2</div>
				<div class="form-input-cell">
					<wd-typeahead name="Morphologie1" [(model)]="data.extendedHeader.morphologie[1]"></wd-typeahead>
				</div>
			</div>
			<div class="form-row" *ngIf="data.extendedHeader.morphologie.length > 2">
				<div class="form-label-cell">Morphologie 3</div>
				<div class="form-input-cell">
					<wd-typeahead name="Morphologie2" [(model)]="data.extendedHeader.morphologie[2]"></wd-typeahead>
				</div>
				<div class="form-label-cell" *ngIf="data.extendedHeader.morphologie.length > 3">Morphologie 4</div>
				<div class="form-input-cell" *ngIf="data.extendedHeader.morphologie.length > 3">
					<wd-typeahead name="Morphologie3" [(model)]="data.extendedHeader.morphologie[3]"></wd-typeahead>
				</div>
				<ng-container *ngIf="data.extendedHeader.morphologie.length <= 3">
					<div class="form-label-cell"></div>
					<div class="form-input-cell"></div>
				</ng-container>
			</div>
			<div class="form-row">
				<div class="form-label-cell">KMgCaP-Serie</div>
				<div class="form-input-cell">
					<wd-list-input [(model)]="data.extendedHeader.kMgCaPSerie" name="KMgCaP-Serie"></wd-list-input>
				</div>
				<div class="form-label-cell"></div>
				<div class="form-input-cell"></div>
			</div>
		}

		<!-- Relief (nicht M) - Erweitert nach SEA -->
		@if (!isM() && data.extendedHeader.relief) {
			<div class="form-section-header">Relief</div>

			<!-- Neigung -->
			<div class="form-row">
				<div class="form-label-cell">Neigung <wd-help name="Neigungsstufe" [context]="{ currentValue: data.extendedHeader.relief.neigungsstufe }"
					(valueSelected)="setzeNeigungsstufe($event)"></wd-help></div>
				<div class="form-input-cell">
					<bp-relief-picker thema="Neigungsstufe" [model]="data.extendedHeader.relief.neigungsstufe"
						(modelChange)="setzeNeigungsstufe($event)"></bp-relief-picker>
				</div>
				<div class="form-label-cell">Grad</div>
				<div class="form-input-cell">
					<wd-number-input name="NeigungGrad" [(model)]="data.extendedHeader.relief.neigungGrad"
						[min]="0" [max]="90" placeholder=""
						(modelChange)="onNeigungGradChange($event)"></wd-number-input>
				</div>
			</div>

			<!-- Wölbung und Hangrichtung -->
			<div class="form-row">
				<div class="form-label-cell">Wölbung <wd-help name="Woelbung" [context]="{ currentValue: data.extendedHeader.relief.woelbung }"
					(valueSelected)="setzeWoelbung($event)"></wd-help></div>
				<div class="form-input-cell">
					<bp-relief-picker thema="Woelbung" [model]="data.extendedHeader.relief.woelbung"
						(modelChange)="setzeWoelbung($event)"></bp-relief-picker>
				</div>
				<div class="form-label-cell">Hangrichtung <wd-help name="Hangrichtung"></wd-help></div>
				<div class="form-input-cell">
					@if (istHangmitRichtung()) {
						<wd-list-input name="Hangrichtung" [(model)]="data.extendedHeader.relief.hangrichtung"></wd-list-input>
					} @else {
						<span class="text-muted">—</span>
					}
				</div>
			</div>

			<!-- Einbindung - kontextabhängig -->
			<div class="form-row">
				@if (istEbeneOderRampe()) {
					<!-- Ebene/Rampe: Einbindung in Nachbarschaft -->
					<div class="form-label-cell">Einbindung <wd-help name="ReliefformUmgebung" [context]="{ currentValue: data.extendedHeader.relief.einbindungEbene }"
						(valueSelected)="setzeEinbindungEbene($event)"></wd-help></div>
					<div class="form-input-cell">
						<bp-relief-picker thema="ReliefformUmgebung" [model]="data.extendedHeader.relief.einbindungEbene"
							(modelChange)="setzeEinbindungEbene($event)"></bp-relief-picker>
					</div>
					<div class="form-label-cell"></div>
					<div class="form-input-cell"></div>
				} @else {
					<!-- Hang: Hanganschluss und Hangteil -->
					<div class="form-label-cell">Hanganschluss <wd-help name="Hanganschluss" [context]="{ currentValue: data.extendedHeader.relief.hanganschluss }"
						(valueSelected)="setzeHanganschluss($event)"></wd-help></div>
					<div class="form-input-cell">
						<bp-relief-picker thema="Hanganschluss" [model]="data.extendedHeader.relief.hanganschluss"
							(modelChange)="setzeHanganschluss($event)"></bp-relief-picker>
					</div>
					<div class="form-label-cell">Hangteil <wd-help name="Hangteil"></wd-help></div>
					<div class="form-input-cell">
						<wd-list-input name="Hangteil" [(model)]="data.extendedHeader.relief.hangteil"></wd-list-input>
					</div>
				}
			</div>

			<!-- Höhenspanne (nur bei Hängen) -->
			@if (!istEbeneOderRampe()) {
				<div class="form-row">
					<div class="form-label-cell">Höhenspanne <wd-help name="Hoehenspanne"></wd-help></div>
					<div class="form-input-cell">
						<wd-number-input name="Hoehenspanne" [(model)]="data.extendedHeader.relief.hoehenspanne"
							[min]="0" ></wd-number-input>
					</div>
					<div class="form-label-cell"></div>
					<div class="form-input-cell"></div>
				</div>
			}

			<!-- Innere Rauhheit und Mesoklima teilen sich eine Zeile -->
			<div class="form-row">
				<div class="form-label-cell">Innere Rauhheit <wd-help name="InnereRauhheit"></wd-help></div>
				<div class="form-input-cell">
					<wd-list-input name="InnereRauhheit" [(model)]="data.extendedHeader.relief.innereRauhheit"></wd-list-input>
				</div>
				<div class="form-label-cell">Mesoklima</div>
				<div class="form-input-cell">
					<wd-list-input name="Mesoklima" [(model)]="data.extendedHeader.mesoklima"></wd-list-input>
				</div>
			</div>

			<!-- Legacy-Felder (optional anzeigen) -->
			@if (data.extendedHeader.relief.relief || data.extendedHeader.relief.reliefUmgebung) {
				<div class="form-row text-muted">
					<div class="form-label-cell">Relief (alt)</div>
					<div class="form-input-cell">
						<wd-typeahead name="Reliefform" [(model)]="data.extendedHeader.relief.relief"></wd-typeahead>
					</div>
					<div class="form-label-cell">Umgebung (alt)</div>
					<div class="form-input-cell">
						<wd-typeahead name="ReliefformUmgebung" [(model)]="data.extendedHeader.relief.reliefUmgebung"></wd-typeahead>
					</div>
				</div>
			}
		}

		<!-- Mesoklima steht sonst neben der Inneren Rauhheit. Fehlen die
		     Relief-Angaben, braucht es hier eine eigene Zeile - sonst waere das
		     Feld bei diesen Punkten gar nicht mehr zu erreichen. -->
		<div class="form-row" *ngIf="!isM() && !data.extendedHeader.relief">
			<div class="form-label-cell">Mesoklima</div>
			<div class="form-input-cell">
				<wd-list-input name="Mesoklima" [(model)]="data.extendedHeader.mesoklima"></wd-list-input>
			</div>
			<div class="form-label-cell"></div>
			<div class="form-input-cell"></div>
		</div>

		<!-- Witterung -->
		<div class="form-section-header">Witterung <wd-help name="Witterung" [context]="{bohrpunkt: data}"></wd-help></div>
		<div class="form-row">
			<div class="form-label-cell weather-buttons">
				<button type="button" class="btn btn-sm btn-outline-secondary" (click)="fetchWeather(false)" [disabled]="weatherLoading" title="Wetter für Aufnahmedatum abrufen">
					<span *ngIf="weatherLoading" class="spinner-border spinner-border-sm me-1"></span>
					Datum
				</button>
				<button type="button" class="btn btn-sm btn-outline-secondary" (click)="fetchWeather(true)" [disabled]="weatherLoading" title="Aktuelles Wetter abrufen">
					Jetzt
				</button>
			</div>
			<div class="form-input-cell full-width">
				<wd-text-input name="Witterung" [(model)]="data.extendedHeader.witterung"></wd-text-input>
			</div>
			<button type="button" class="btn btn-sm btn-outline-danger weather-delete-btn" (click)="clearWeather()" *ngIf="data.extendedHeader.witterung" title="Witterung entfernen">
				<i class="bi bi-x-circle"></i>
			</button>
		</div>

		<!-- Grube-spezifische Kopffelder (nur G: Punktart 1-4) -->
		@if (isG()) {
			<div class="form-section-header">Klima</div>
			<div class="form-row">
				<div class="form-label-cell">Klimabereich <wd-help name="Klimabereich"></wd-help></div>
				<div class="form-input-cell full-width">
					<wd-an-typeahead name="Klimabereich" [(model)]="data.extendedHeader.klimabereich!" [acceptOtherValues]="true"></wd-an-typeahead>
				</div>
			</div>

			<div class="form-section-header">Standort (Grube)</div>
			<div class="form-row">
				<div class="form-label-cell">Grundgestein/Sediment</div>
				<div class="form-input-cell">
					<wd-text-input name="GrundgesteinSediment" [(model)]="data.extendedHeader.grundgesteinSediment"></wd-text-input>
				</div>
				<div class="form-label-cell">Meereshöhe [m]</div>
				<div class="form-input-cell">
					<wd-number-input name="Meereshoehe" [(model)]="data.extendedHeader.meereshoehe"></wd-number-input>
				</div>
			</div>
			<div class="form-row">
				<div class="form-label-cell">Mesorelief</div>
				<div class="form-input-cell">
					<wd-text-input name="Mesorelief" [(model)]="data.extendedHeader.mesorelief"></wd-text-input>
				</div>
				<div class="form-label-cell">Lage der Grube</div>
				<div class="form-input-cell">
					<wd-text-input name="LageGrube" [(model)]="data.extendedHeader.lage"></wd-text-input>
				</div>
			</div>
			<div class="form-row">
				<div class="form-label-cell">Standortklimat. Angaben</div>
				<div class="form-input-cell full-width">
					<wd-textarea name="StandortklimatischeAngaben" [(model)]="data.extendedHeader.standortklimatischeAngaben" modalContainerSelector="bp-hl-area-container"></wd-textarea>
				</div>
			</div>

			<div class="form-section-header">Mosaikbereich</div>
			<div class="form-row">
				<div class="form-label-cell">Nummer</div>
				<div class="form-input-cell">
					<wd-text-input name="MosaikNummer" [(model)]="data.extendedHeader.mosaikBereich!.nummer"></wd-text-input>
				</div>
				<div class="form-label-cell">Name</div>
				<div class="form-input-cell">
					<wd-text-input name="MosaikName" [(model)]="data.extendedHeader.mosaikBereich!.name"></wd-text-input>
				</div>
			</div>
			<div class="form-row">
				<div class="form-label-cell">Haupttyp</div>
				<div class="form-input-cell full-width">
					<wd-text-input name="MosaikHaupttyp" [(model)]="data.extendedHeader.mosaikBereich!.haupttyp"></wd-text-input>
				</div>
			</div>

			<div class="form-section-header">Humusform &amp; Bestockung</div>
			<div class="form-row">
				<div class="form-label-cell">Humusform Gesamtfläche <wd-help name="HumusformGesamt"></wd-help></div>
				<div class="form-input-cell">
					<wd-an-typeahead name="HumusformGesamt" [(model)]="data.header.humusform.gesamtFlaeche!" [acceptOtherValues]="true"></wd-an-typeahead>
				</div>
				<div class="form-label-cell">Humusform morphologisch <wd-help name="HumusformMorphologisch"></wd-help></div>
				<div class="form-input-cell">
					<wd-an-typeahead name="HumusformMorphologisch" [(model)]="data.header.humusform.morphologisch!" [acceptOtherValues]="true"></wd-an-typeahead>
				</div>
			</div>
			<div class="form-row">
				<div class="form-label-cell">Bestockungstyp <wd-help name="Bestockungstyp"></wd-help></div>
				<div class="form-input-cell full-width">
					<wd-an-typeahead name="Bestockungstyp" [(model)]="data.extendedHeader.bestockungsTyp!" [acceptOtherValues]="true"></wd-an-typeahead>
				</div>
			</div>
			<div class="form-row">
				<div class="form-label-cell">STFG Zustand <wd-help name="ZustandsSTFG"></wd-help></div>
				<div class="form-input-cell">
					<wd-an-typeahead name="ZustandsSTFG" [(model)]="data.extendedHeader.stfg.zustands!" [acceptOtherValues]="true"></wd-an-typeahead>
				</div>
				<div class="form-label-cell">STFG Immissions</div>
				<div class="form-input-cell">
					<wd-an-typeahead name="ImmissionsSTFG" [(model)]="data.extendedHeader.stfg.imissions!" [acceptOtherValues]="true"></wd-an-typeahead>
				</div>
			</div>

			<div class="form-section-header">Vornutzung &amp; Eingriffe</div>
			<div class="form-row">
				<div class="form-label-cell">Vorbestandliche Geschichte</div>
				<div class="form-input-cell full-width">
					<wd-textarea name="VorbestandlicheGeschichte" [(model)]="data.extendedHeader.vorbestandlicheGeschichte" modalContainerSelector="bp-hl-area-container"></wd-textarea>
				</div>
			</div>
			<div class="form-row">
				<div class="form-label-cell">Forstliche Bodenbearbeitung</div>
				<div class="form-input-cell">
					<wd-text-input name="ForstlicheBodenbearbeitung" [(model)]="data.extendedHeader.forstlicheBodenbearbeitung"></wd-text-input>
				</div>
				<div class="form-label-cell">Anthropogene Beeinflussung</div>
				<div class="form-input-cell">
					<wd-text-input name="AnthropogeneBeeinflussung" [(model)]="data.extendedHeader.anthropogeneBeeinflussung"></wd-text-input>
				</div>
			</div>
			<div class="form-row">
				<div class="form-label-cell">Düngemittelart</div>
				<div class="form-input-cell">
					<wd-text-input name="DuengemittelArt" [(model)]="data.extendedHeader.duengemittelArt"></wd-text-input>
				</div>
				<div class="form-label-cell">Herbizide</div>
				<div class="form-input-cell">
					<wd-text-input name="Herbizide" [(model)]="data.extendedHeader.herbizide"></wd-text-input>
				</div>
			</div>
			<div class="form-row">
				<div class="form-label-cell">Insektizide</div>
				<div class="form-input-cell">
					<wd-text-input name="Insektizide" [(model)]="data.extendedHeader.insektizide"></wd-text-input>
				</div>
				<div class="form-label-cell">Grund-/Stauwasserveränderungen</div>
				<div class="form-input-cell">
					<wd-text-input name="GrundStauwasserVeraenderungen" [(model)]="data.extendedHeader.grundStauwasserVeraenderungen"></wd-text-input>
				</div>
			</div>

			<div class="form-section-header">Waldbauliches</div>
			<div class="form-row">
				<div class="form-label-cell">Begründungsart <wd-help name="Begründungsart"></wd-help></div>
				<div class="form-input-cell">
					<wd-typeahead name="Begründungsart" [(model)]="data.extendedHeader.begruendungsart"></wd-typeahead>
				</div>
				<div class="form-label-cell">Mischform <wd-help name="Mischform"></wd-help></div>
				<div class="form-input-cell">
					<wd-typeahead name="Mischform" [(model)]="data.extendedHeader.mischform"></wd-typeahead>
				</div>
			</div>
			<div class="form-row">
				<div class="form-label-cell">Waldfunktion <wd-help name="Waldfunktion"></wd-help></div>
				<div class="form-input-cell full-width">
					<wd-typeahead name="Waldfunktion" [(model)]="data.extendedHeader.waldfunktion"></wd-typeahead>
				</div>
			</div>
		}

		<!-- Moortypen (nur M) -->
		<ng-container *ngIf="isM()">
			<div class="form-section-header">Moortypen</div>
			<div class="form-row">
				<div class="form-label-cell">Ökolog. Typ <wd-help name="OekologischerMoortyp"></wd-help></div>
				<div class="form-input-cell">
					<wd-typeahead name="Ökologischer Moortyp" [(model)]="data.extendedHeader.moorTyp!.oekologisch"></wd-typeahead>
				</div>
				<div class="form-label-cell">Hydrogen. Typ <wd-help name="HydrogenetischerMoortyp"></wd-help></div>
				<div class="form-input-cell">
					<wd-typeahead name="Hydrogenetischer Moortyp" [(model)]="data.extendedHeader.moorTyp!.hydrogenetisch"></wd-typeahead>
				</div>
			</div>
			<div class="form-row" *ngIf="data.extendedHeader.relief">
				<div class="form-label-cell">Relief Best.</div>
				<div class="form-input-cell">
					<wd-list-input name="Reliefform Bestand" [(model)]="data.extendedHeader.relief.reliefBestand"></wd-list-input>
				</div>
				<div class="form-label-cell">Relief Veg.</div>
				<div class="form-input-cell">
					<wd-list-input name="Reliefform Bodenvegetation" [(model)]="data.extendedHeader.relief.reliefBodenvegetation"></wd-list-input>
				</div>
			</div>
		</ng-container>
	</div>
</bp-hl-area-container>
